import {gql} from "@apollo/client";

export const FGM_GLOBAL_ALERT_STATE_FIELDS = gql`
  fragment GlobalAlertStateFields on GlobalAlertState {
    id
    created_at
    up_at
    state_has_changed
    state_is_up
    num_locations_down
    service_is_deleted
    service_monitoring_type
    ignored
    service_id
    status
  }
`;

export const FGM_ALERT_LIST_ITEM_FIELDS = gql`
  fragment AlertListItemFields on GlobalAlertState {
    ...GlobalAlertStateFields
    alert {
      id
      created_at
      monitoring_server {
        id
        location
      }
    }
    down_alerts {
      id
      created_at
      monitoring_server {
        id
        location
      }
    }
    service {
      id
      name
      is_paused
      is_deleted
      monitoring_service_type
      msp_address
      device {
        id
        address
      }
      tags {
        id
        tag
        color_hex
      }
    }
  }
`;
